import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "pop_up flex_box com_pop",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "result_form" }
const _hoisted_4 = { class: "li_con" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "li_con" }
const _hoisted_7 = { class: "_flex _center btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("p", null, "1:1 문의 답변", -1)),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "form_li_tit" }, "작성자", -1)),
            _createElementVNode("span", null, _toDisplayString($setup.props.data.userName), 1)
          ]),
          _createElementVNode("li", null, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "form_li_tit" }, "작성일", -1)),
            _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.props.data.createDate), ".", true)), 1)
          ]),
          _createElementVNode("li", null, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "form_li_tit" }, "제목", -1)),
            _createElementVNode("span", null, _toDisplayString($setup.props.data.title), 1)
          ]),
          _createElementVNode("li", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              for: "qna_q",
              class: "form_li_tit"
            }, "내용", -1)),
            _createElementVNode("textarea", {
              name: "",
              id: "qna_q",
              class: "custom_scroll h_200",
              disabled: "",
              textContent: _toDisplayString($setup.props.data.content)
            }, null, 8, _hoisted_5)
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("li", _hoisted_6, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              for: "qna_a",
              class: "form_li_tit"
            }, "답변", -1)),
            _withDirectives(_createElementVNode("textarea", {
              name: "",
              id: "qna_a",
              class: "custom_scroll",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.props.data.comment) = $event))
            }, null, 512), [
              [_vModelText, $setup.props.data.comment]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "submit_btn _130 _gray",
            style: {"margin-top":"10px"},
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
          }, "취소"),
          (!$setup.props.isEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "submit_btn _130 _main_blue",
                style: {"margin-top":"10px"},
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.save(false)))
              }, "답변 등록"))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "submit_btn _130 _main_blue",
                style: {"margin-top":"10px"},
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.save(true)))
              }, "답변 수정"))
        ])
      ])
    ])
  ], 64))
}